import { g as t } from "./index793.mjs";
var e = t, n = e("document", "documentElement");
export {
  n as h
};
